import React from "react";
import { Row, Col, Label, FormFeedback } from "reactstrap";
import Flatpickr from "react-flatpickr";

const TimelineInput = ({ validation }: { validation: any }) => {
  return (
    <Row>
      <Col md={6} className="mb-3">
        <Label htmlFor="startDate-field" className="form-label">
          Start Date
        </Label>
        {/* @ts-ignore */}
        <Flatpickr
          name="startDate"
          id="startDate-field"
          className="form-control"
          placeholder="Select start date"
          options={{
            enableTime: false,
            altInput: false,
            altFormat: "d M, Y",
            dateFormat: "d M, Y",
          }}
          onChange={(e) => {
            validation.setFieldValue("startDate", e[0]);
          }}
          value={validation.values.startDate || ""}
        />
        {validation.touched.startDate && validation.errors.startDate ? (
          <FormFeedback type="invalid">
            {validation.errors.startDate}
          </FormFeedback>
        ) : null}
      </Col>
      <Col md={6} className="mb-3">
        <Label htmlFor="endDate-field" className="form-label">
          End Date
        </Label>
        {/* @ts-ignore */}
        <Flatpickr
          name="endDate"
          id="endDate-field"
          className="form-control"
          placeholder="Select end date"
          options={{
            enableTime: false,
            altInput: false,
            altFormat: "d M, Y",
            dateFormat: "d M, Y",
          }}
          onChange={(e) => {
            validation.setFieldValue("endDate", e[0]);
          }}
          value={validation.values.endDate || ""}
        />
        {validation.touched.endDate && validation.errors.endDate ? (
          <FormFeedback type="invalid">
            {validation.errors.endDate}
          </FormFeedback>
        ) : null}
      </Col>
    </Row>
  );
};

export default TimelineInput;
